import React from 'react';

import { RehireEligibleFormBody } from './rehire-eligible-form-body';

type InputProps = ReduxFormFieldProps<string> & {
  employee?: Employee;
};

export const RehireEligibleReduxFormComponent = ({ employee, input }: InputProps) => (
  <RehireEligibleFormBody
    employee={employee}
    rehireEligible={input.value || null}
    setRehireEligible={input.onChange}
  />
);
